import type Phaser from 'phaser';

/**
 * Debug-mode flag + helpers. Enabled for the session only when the game is
 * opened with `?debug` (set by BootScene). When active, every normal screen
 * gets an "Esc → Demo" affordance so you can return to DemoScene after jumping
 * into a screen from it. Off by default, so normal play is unaffected.
 *
 * The flag also sandboxes the save: `saveStorage()` reads this to hand debug
 * sessions a throwaway copy-on-write view of localStorage, so nothing a debug
 * session does to progress survives the page. See `src/render/saveStorage.ts`.
 */
let debugEnabled = false;

export function setDebugEnabled(on: boolean): void {
  debugEnabled = on;
}

export function isDebugEnabled(): boolean {
  return debugEnabled;
}

/**
 * When debug mode is active, wire Esc on `scene` to return to DemoScene (and
 * draw a small corner hint). No-op when debug mode is off.
 */
export function installDebugReturn(scene: Phaser.Scene): void {
  if (!debugEnabled) return;

  const back = (): void => {
    scene.scene.stop('HudScene'); // harmless if not running
    scene.scene.start('DemoScene');
  };
  scene.input.keyboard?.on('keydown-ESC', back);

  scene.add
    .text(10, 710, '⮌ Esc → Demo · save sandboxed', {
      fontSize: '13px',
      color: '#f5c518',
      backgroundColor: '#000000aa',
      padding: { x: 6, y: 3 },
    })
    .setOrigin(0, 1)
    .setScrollFactor(0)
    .setDepth(9999);
}
